import type { TGlobalProduct } from "../../data";
import type { TOption } from "../components/Autocomplete/Autocomplete";
import { globalProductName, packageNameWithSource } from "../utils";

/** Maps a third-party (global) product into an Autocomplete option with folder + source. */
export function toGlobalCurveOption(p: TGlobalProduct): TOption {
  const packageName = p.globalPackageByGlobalPackage?.name || "";
  const sourceName = p.globalPackageByGlobalPackage?.sourceBySource?.name ?? "";
  const packageWithSource = packageNameWithSource({
    globalPackageByGlobalPackage: p.globalPackageByGlobalPackage,
  });
  const groupLabel = packageWithSource || packageName;

  return {
    label: globalProductName(p),
    value: p.id,
    groupValue: groupLabel,
    groupLabel,
    groupKey: String(p.global_package ?? p.globalPackageByGlobalPackage?.id ?? p.id),
    shortName: p.name,
    longName: p.description !== p.name ? p.description : undefined,
    sortSourceType: p.globalPackageByGlobalPackage?.sourceBySource?.source_type ?? "organisation",
    sortSourceName: sourceName,
    sortPackageName: packageName,
    sourceLabel: sourceName || undefined,
  };
}
